import { DOMAIN_HIERARCHY_LIMIT } from '@/shared/lib/constants';
import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { domainKeys } from '@/shared/lib/query/queryKeys';

import { getDomainHierarchyApi } from '@/entities/domain/api';
import type { DomainHierarchyResponse } from '@/entities/domain/domain';

type UseDomainHierarchyParams = {
  limit?: number;
};

export const useDomainHierarchy = ({ limit = DOMAIN_HIERARCHY_LIMIT }: UseDomainHierarchyParams = {}) => {
  return useQueryWithBoundary<DomainHierarchyResponse>({
    queryKey: domainKeys.hierarchy(limit),
    queryFn: () => getDomainHierarchyApi({ limit }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
